import React, { PureComponent, Fragment } from 'react';
import { map } from 'lodash';
import { Select, Cascader } from 'antd';
// import { LinkType } from '.';

export class LinkTypeSelector extends PureComponent<any> {
    changeCascader = (value) => {
        const { onChange } = this.props;
        onChange(value[value.length - 1]);
    };

    /**
     * 根据子节点拿到树全路径，所有叶子节点id必须唯一
     * @param nodes
     * @param leafValue
     */
    treeValues = (nodes, leafValue) => {
        const result = [];
        function treePath(roots) {
            let found = false;
            roots.forEach((node) => {
                if (node.id === leafValue) {
                    result.push(node.id);
                    found = true;
                    return;
                }
                if (node.children && node.children.length > 0) {
                    result.push(node.id);
                    if (treePath(node.children)) {
                        found = true;
                    } else {
                        result.pop();
                    }
                }
            });
            return found;
        }
        treePath(nodes);
        return result;
    };

    renderCascader = () => {
        const { value, linkTypes } = this.props;
        let selectValue = value ? value.linkType : 'none';
        const values = this.treeValues(linkTypes, selectValue);
        return (
            <Cascader
                placeholder="请选择"
                className="link-type"
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                options={linkTypes}
                value={values}
                onChange={this.changeCascader}
            ></Cascader>
        );
    };

    render() {
        const { value, linkTypes, onChange, linkTypeMode = 'select', disabled } = this.props;
        let selectValue = value ? value.linkType : 'none';
        return (
            <Fragment>
                {linkTypeMode === 'select' && (
                    <Select
                        placeholder="请选择"
                        className="link-type"
                        value={selectValue}
                        onChange={onChange}
                        disabled={disabled}
                    >
                        {map(linkTypes, function(type) {
                            return (
                                <Select.Option key={type.id} value={type.id}>
                                    {type.name}
                                </Select.Option>
                            );
                        })}
                    </Select>
                )}
                {linkTypeMode === 'cascader' && this.renderCascader()}
            </Fragment>
        );
    }
}
